export const emailValidatorRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/